import { ErrorType, OperationType, QueryError } from "../../types";
import fetchMsalJson from "../fetchMsalJson";
import { RoleRow } from "./models";

const getRoles = async (): Promise<RoleRow[]> => {
  try {
    const endpoint = `${process.env.REACT_APP_API_BASE_URL}/get_roles`;

    const result = await fetchMsalJson("GET", endpoint);

    if (!result) throw new QueryError(ErrorType.UNKNOWN, "Erreur inconnue.");

    if (result.status !== 200) {
      throw new QueryError(ErrorType.INTERNAL, await result.text());
    }

    return await result.json();

  } catch (e) {
    throw QueryError.TransformUnknown(
        e,
        "Rôle",
        OperationType.RETRIEVEMULTIPLE
      );
  }
};

export { getRoles };
